export const textConstants = {
	1: {
		currency: "CLP",
		delivery: "Guía de despacho",
		generic: "Genérico",
		otherMovement: "Otros movimientos",
	},
	2: {
		currency: "UYU",
		delivery: "Remito",
		generic: "Granel",
		otherMovement: "Registro de movimientos",
	},
};
